import { createContext } from 'react';
import type { User, LoginResult } from '@/features/auth';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<LoginResult>;
  completeMfa: (tmpToken: string, code: string) => Promise<void>;
  completeMfaEnroll: (tmpToken: string, code: string) => Promise<string[]>;
  logout: () => void;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
